import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { NuqsAdapter } from 'nuqs/adapters/react-router';
import { AuthProviderV2 } from '@/contexts/AuthContextV2';
import { NotificationProvider } from '@/contexts/NotificationContext';
import { ToastNotifications } from '@/components/ToastNotifications';
import { VersionUpdateNotification } from '@/components/VersionUpdateNotification';
import { Router } from '@/router';
import { theme } from '@/theme';
import { ReceiptBatchImportDialog } from '@/components/receipt-import';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProviderV2>
          <NotificationProvider>
            <ToastNotifications />
            <VersionUpdateNotification />
            <BrowserRouter>
              <NuqsAdapter>
                <Router />
                <ReceiptBatchImportDialog open={false} onClose={() => {}} />
              </NuqsAdapter>
            </BrowserRouter>
          </NotificationProvider>
        </AuthProviderV2>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
